import { render, staticRenderFns } from "./UserDetailsBasicInfo.vue?vue&type=template&id=e11432b6&"
import script from "./UserDetailsBasicInfo.vue?vue&type=script&lang=js&"
export * from "./UserDetailsBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports